var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSelect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0999 8.66676L12.4388 5.32783C12.7429 5.02373 12.7429 4.53218 12.4388 4.22808C12.1347 3.92397 11.6431 3.92397 11.339 4.22808L8.00016 7.56701L4.6613 4.22808C4.3572 3.92397 3.86567 3.92397 3.56157 4.22808C3.25747 4.53218 3.25747 5.02373 3.56157 5.32783L6.90043 8.66676L3.56157 12.0057C3.25747 12.3098 3.25747 12.8013 3.56157 13.1054C3.71323 13.2571 3.91233 13.3333 4.11144 13.3333C4.31054 13.3333 4.50964 13.2571 4.6613 13.1054L8.00016 9.76652L11.339 13.1054C11.4907 13.2571 11.6898 13.3333 11.8889 13.3333C12.088 13.3333 12.2871 13.2571 12.4388 13.1054C12.7429 12.8013 12.7429 12.3098 12.4388 12.0057L9.0999 8.66676Z",
    fill: "#B0B3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSelect);
export default __webpack_public_path__ + "static/media/closeSelect.08d9a2bb8e727ac8ec6eb2d9719372db.svg";
export { ForwardRef as ReactComponent };